import React, { useEffect, useState } from "react";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { Link } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import {
  delete_Record,
  ActiveInactive_Record,
  errorMessage,
} from "../CommonFunctions";
import { SVGICON } from "../../../constant/theme";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import {
  POST_GetMachiningOutwardInwardDetailByID,
  POST_GetMachiningOutwardList,
  POST_GetVendorsDDLList,
  POST_MachiningOutwardActiveInActive,
  POST_MachiningOutwardDelete,
  POST_MachiningOutwardExport,
  POST_MachiningOutwardGetPassPrint,
} from "../../../helpers/url_helper";
import { useFilter } from "../../../../context/FilterContext";

const MachineOutward = () => {
  const { filter, updateFilter } = useFilter();

  const isFilterExpanded =
    JSON.parse(localStorage.getItem("userDetails"))?.IsFilterExpanded === true;
  const [showFilter, setShowFilter] = useState(isFilterExpanded);

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "machining-outward" ? filter?.CurrentPage : 1,
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "machining-outward" ? filter?.PageSize : 10,
  );
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "machining-outward" ? filter?.sortBy : "",
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "machining-outward" ? filter?.orderBy : "asc",
  );

  const [isReset, setIsReset] = useState(false);

  // const [machineOutwardList, setMachineOutwardList] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [tCNosOptions, setTCNosOptions] = useState([]);

  const [showMachiningOutwardModal, setShowMachiningOutwardModal] =
    useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "Pending", value: 1 },
    { label: "Partial Done", value: 2 },
    { label: "Done", value: 3 },
  ];

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      Status:
        filter && filter?.page == "machining-outward" ? filter?.Status : "",
      OutwardStatus:
        filter && filter?.page == "machining-outward"
          ? filter?.OutwardStatus
          : 0,
      FromDate:
        filter && filter?.page == "machining-outward"
          ? filter?.FromDate
          : new Date(),
      ToDate:
        filter && filter?.page == "machining-outward"
          ? filter?.ToDate
          : new Date(),
      VendorIDEncrypted:
        filter && filter?.page == "machining-outward"
          ? filter?.VendorIDEncrypted
          : "",
      OutwardNo:
        filter && filter?.page == "machining-outward" ? filter?.OutwardNo : "",
      TCNos: filter && filter?.page == "machining-outward" ? filter?.TCNos : "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: {
      FromDate,
      ToDate,
      VendorIDEncrypted,
      OutwardNo,
      TCNos,
      Status,
      OutwardStatus,
    },
  } = formikFilter;

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      Status: "",
      OutwardStatus: 0,
      FromDate: new Date(),
      ToDate: new Date(),
      VendorIDEncrypted: "",
      OutwardNo: "",
      TCNos: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "machining-outward",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      Status: Status,
      OutwardStatus: OutwardStatus,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      VendorIDEncrypted: VendorIDEncrypted,
      OutwardNo: OutwardNo,
      TCNos: TCNos,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Array.from(Status, (x) => x.value).join(","),
      OutwardStatus: OutwardStatus,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,

      OutwardFromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      OutwardToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",

      MachiningOutwardNo: OutwardNo,
      VendorIDEncrypted: VendorIDEncrypted,
      TCNos: TCNos,
    };

    await post(POST_GetMachiningOutwardList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        // setMachineOutwardList(response?.MachiningOutwards);
        formik.setFieldValue("machineOutwardList", response?.MachiningOutwards);
        setIsLoading(false);

        if (page > 1 && response?.MachiningOutwards?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  useEffect(() => {
    getVendorDDL();
  }, []);

  const getVendorDDL = async () => {
    setIsLoading(true);
    await post(POST_GetVendorsDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setVendorOptions(
            response?.VendorsList?.map((item) => ({
              label: item.VendorName,
              value: item.VendorIDEncrypt,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      Status: Array.from(Status, (x) => x.value).join(","),
      OutwardStatus: OutwardStatus,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,

      OutwardFromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      OutwardToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",

      MachiningOutwardNo: OutwardNo,
      VendorIDEncrypted: VendorIDEncrypted,
      TCNos: TCNos,
    };
    post(POST_MachiningOutwardExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const PrintGatePass = (id) => {
    setIsLoading(true);
    let payload = {
      MachiningOutwardIDEncrypt: id,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    };
    post(POST_MachiningOutwardGetPassPrint, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({});

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      machineOutwardList: [],
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { machineOutwardList },
  } = formik;

  const getViewMachiningOutwardDetails = async (machiningOutwardID) => {
    setIsLoading(true);
    // getMachiningOutwardInwardDetails(machiningOutwardID);
    if (machiningOutwardID) {
      await post(POST_GetMachiningOutwardInwardDetailByID, {
        MachiningOutwardIDEncrypt: machiningOutwardID,
        CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
        ViewType: 2, // 2 -- Inward/Outward Display
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formikMachiningOutward.setValues({
              MachiningOutwardIDEncrypt: response?.MachiningOutwardIDEncrypt,
              VendorIDEncrypt: response?.VendorIDEncrypt,
              VendorName: response?.VendorName,
              MachiningOutwardNo: response?.MachiningOutwardNo,
              OutwardDate: response?.OutwardDate,
              ExpectedDate: response?.ExpectedDate,
              Remarks: response?.OutwardRemarks,
              InwardRemarks: response?.InwardRemarks,

              ListOfVendorProcessDetail: response?.MachiningOutwardDetails?.map(
                (item) => ({
                  MachiningConfigurationIDEncrypt:
                    item?.MachiningConfigurationIDEncrypt,
                  InwardMaterialIDEncrypt: item?.InwardMaterialIDEncrypt,
                  InwardMachiningDetailIDEncrypt:
                    item?.InwardMachiningDetailIDEncrypt,
                  ProcessName: item?.ProcessName,
                  TCNo: item?.TCNo,
                  Note: item?.MachiningNote,
                  Qty: item?.Qty,
                  Length: item?.Length,
                  Thickness: item?.Thickness,
                  VendorRate: item?.VendorRate,
                  InvoiceRate: item?.InvoiceRate,
                  IsDelete: item?.IsDelete,
                  IsSelectedInvoicing: item?.Invoicing,
                  IsSelected: item?.IsSelected,
                  MachiningOutwardIDEncrypt: item?.MachiningOutwardIDEncrypt,
                  MachiningOutwardDetailIDEncrypt:
                    item?.MachiningOutwardDetailIDEncrypt,
                  OutwardStatusName: item?.OutwardStatusName,
                  display: true,
                  IsHold: item?.IsHold,
                  HoldReason: item?.HoldReason,
                }),
              ),
            });
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });

      setShowMachiningOutwardModal(true);
      setIsLoading(false);
    }
  };

  const validationSchemaMachiningOutward = Yup.object().shape({});

  const formikMachiningOutward = useFormik({
    validationSchemaMachiningOutward,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitMachiningOutward(values, formikHelpers),
    initialValues: {
      MachiningOutwardIDEncrypt: "",
      VendorIDEncrypt: "",
      VendorName: "",
      MachiningOutwardNo: "",
      OutwardDate: "",
      ExpectedDate: "",
      Remarks: "",
      InwardRemarks: "",
      ListOfVendorProcessDetail: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { ListOfVendorProcessDetail, InwardRemarks },
  } = formikMachiningOutward;

  const handleValidSubmitMachiningOutward = (values) => {};

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Machining Outward</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore" aria-hidden="true"></i>
                    {"  "}
                    Reset
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i>Reload
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 28 && x?.IsExport)
                    ?.length > 0 ? (
                    <Link
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={exportReport}
                    >
                      <i className="fa-solid fa-file-excel" /> Export Report
                    </Link>
                  ) : (
                    ""
                  )}
                  {AuthUser?.Permissions?.Machining == 1 &&
                  (AuthUser?.UserType !== 1 ||
                    formsList?.filter((x) => x?.FormID == 28 && x?.IsAdd)
                      ?.length > 0) ? (
                    <Link
                      to="/add-machining-outward"
                      // className="btn btn-primary btn-sm"
                      className="btn btn-outline-primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add Machining Outward
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="Outward No"
                              name="OutwardNo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                              autoFocus={isFilterExpanded}
                            />
                          </Col>
                          <Col lg={3}>
                            <label className="mb-1">Outward Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>

                          <Col lg={3}>
                            <Field
                              label="Vendor"
                              name="VendorIDEncrypted"
                              placeholder={"Select Vendor"}
                              options={vendorOptions}
                              component={CustomSelect}
                              //isClearable={false}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="TC No"
                              name="TCNos"
                              placeholder={"TC No..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Status"
                              name="Status"
                              placeholder={"Select Status"}
                              options={statusOptions}
                              component={CustomMultiSelect}
                              isMulti={true}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  // className="btn btn-primary btn-sm mb-1"
                                  className="btn btn-primary btn-sm mb-1"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div
                  id="MachineOutward-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="MachineOutward-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="10%"></th>
                        <th
                          style={{
                            width: "30%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("VendorName");
                          }}
                        >
                          Vendor Name
                          <span className="ml-1">
                            {sortBy == "VendorName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "18%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("MachiningOutwardNo");
                          }}
                        >
                          Outward No{" "}
                          <span className="ml-1">
                            {sortBy == "MachiningOutwardNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "14%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("OutwardDate");
                          }}
                        >
                          Outward Date{" "}
                          <span className="ml-1">
                            {sortBy == "OutwardDate" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "14%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("ExpectedDate");
                          }}
                        >
                          Expected Date{" "}
                          <span className="ml-1">
                            {sortBy == "ExpectedDate" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "12%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("Status");
                          }}
                        >
                          Status{" "}
                          <span className="ml-1">
                            {sortBy == "Status" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {machineOutwardList?.length > 0 ? (
                        machineOutwardList?.map((item, indx) => (
                          <React.Fragment key={indx}>
                            <tr
                              key={indx}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                formik.setFieldValue(
                                  `machineOutwardList[${indx}].showTCNo`,
                                  !item.showTCNo,
                                );
                              }}
                            >
                              <td>
                                {item.OutwardStatus < 3 &&
                                AuthUser?.Permissions?.Machining == 1 &&
                                (AuthUser?.UserType !== 1 ||
                                  formsList?.filter(
                                    (x) => x?.FormID == 28 && x?.IsEdit,
                                  )?.length > 0) ? (
                                  <Link
                                    to={`/edit-machining-outward/${window.btoa(
                                      item.MachiningOutwardIDEncrypt,
                                    )}`}
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="Edit"
                                  >
                                    {SVGICON.EditPrimary}
                                  </Link>
                                ) : (
                                  <span style={{ marginRight: "26px" }}></span>
                                )}
                                {/* {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 28 && x?.IsActive
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    // className={`icon-box icon-box-md bg-${
                                    //   item.IsActive == true ? "success" : "danger"
                                    // }-light me-1`}
                                    className={`icon-box icon-box-md me-1`}
                                    title={
                                      item.IsActive == true
                                        ? "Active"
                                        : "Inactive"
                                    }
                                    onClick={() => {
                                      ActiveInactive_Record(
                                        item.IsActive,
                                        POST_MachiningOutwardActiveInActive,
                                        {
                                          MachiningOutwardIDEncrypt:
                                            item.MachiningOutwardIDEncrypt,
                                          IsActive: !item.IsActive,
                                          ModifiedByEncrypt:
                                            AuthUser?.ReferenceIDEncrypt
                                              ? AuthUser?.ReferenceIDEncrypt
                                              : "0",
                                        },
                                        setIsLoading,
                                        fnCallback,
                                        item.MachiningOutwardNo
                                      );
                                    }}
                                  >
                                    <i
                                      className={`fa fa-circle fs-15 ${
                                        item.IsActive == true
                                          ? "text-success"
                                          : "text-danger"
                                      }`}
                                    ></i>
                                  </Link>
                                ) : (
                                  ""
                                )} */}
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 28 && x?.IsDelete,
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      delete_Record(
                                        POST_MachiningOutwardDelete,
                                        {
                                          MachiningOutwardIDEncrypt:
                                            item.MachiningOutwardIDEncrypt,
                                          ModifiedByEncrypt:
                                            AuthUser?.ReferenceIDEncrypt
                                              ? AuthUser?.ReferenceIDEncrypt
                                              : "0",
                                        },
                                        setIsLoading,
                                        fnCallback,
                                        item.MachiningOutwardNo,
                                      );
                                    }}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                ) : (
                                  ""
                                )}

                                <Link
                                  // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                  className="icon-box icon-box-md me-1"
                                  title="View Machining Outward"
                                  onClick={() => {
                                    getViewMachiningOutwardDetails(
                                      item?.MachiningOutwardIDEncrypt,
                                    );
                                  }}
                                >
                                  {SVGICON.NoteText}
                                </Link>
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 28 && x?.IsEdit,
                                )?.length > 0 ? (
                                  <Link
                                    // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                    className="icon-box icon-box-md me-1"
                                    title="Machining Inward"
                                    to={`/add-machining-inward/${window.btoa(
                                      item.MachiningOutwardIDEncrypt,
                                    )}`}
                                  >
                                    {SVGICON.ThirdParty}
                                  </Link>
                                ) : (
                                  ""
                                )}
                                <Link
                                  to="#"
                                  // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                  className="icon-box icon-box-md me-1"
                                  title="Print Gatepass"
                                  onClick={() => {
                                    PrintGatePass(
                                      item?.MachiningOutwardIDEncrypt,
                                    );
                                  }}
                                >
                                  <i
                                    className="fa fa-id-card"
                                    aria-hidden="true"
                                  ></i>
                                </Link>
                              </td>
                              <td>{item.VendorName}</td>
                              <td>{item.MachiningOutwardNo}</td>
                              <td>{item.OutwardDate}</td>
                              <td>{item.ExpectedDate}</td>
                              <td style={{ textAlign: "left" }}>
                                {item.OutwardStatusName}
                              </td>
                            </tr>
                            {item.ListOfTCNo?.length > 0 ? (
                              <tr
                                style={{
                                  display: item.showTCNo == true ? "" : "none",
                                }}
                              >
                                <td></td>
                                {/* <td colSpan={6}>
                                  <div className="table-responsive no-footer">
                                    <table className="table dataTable no-footer mb-0">
                                      <tr>
                                        <td
                                          className="p-1"
                                          style={{
                                            textAlign: "justify",
                                            whiteSpace: "initial",
                                            borderBottomColor: "transparent",
                                          }}
                                        > */}
                                <td
                                  colSpan={6}
                                  style={{
                                    textAlign: "left",
                                    whiteSpace: "initial",
                                  }}
                                  className="p-2"
                                >
                                  {item.ListOfTCNo?.map((itemTC, indxtest) => (
                                    <React.Fragment key={indxtest}>
                                      <Link
                                        // className="badge mb-2 me-2"
                                        className="btn-sm me-2"
                                        // style={{
                                        //   backgroundColor: "#4aa493",
                                        //   color: "#fff",
                                        //   cursor: "default",
                                        // }}
                                        style={{
                                          backgroundColor:
                                            itemTC?.OutwardStatus == 1
                                              ? "#80c9ff"
                                              : itemTC?.OutwardStatus == 2
                                                ? "#4aa493"
                                                : "#ed7c79",
                                          color: "#fff",
                                          cursor: "default",
                                        }}
                                      >
                                        {itemTC.TCNo}{" "}
                                        {itemTC?.IsHold == true && (
                                          <>
                                            <b>[Hold]</b>
                                            <OverlayTrigger
                                              trigger={["hover", "focus"]}
                                              key={indxtest}
                                              responsive={true}
                                              overlay={
                                                <Tooltip className="toltip-popover">
                                                  <strong className="p-1">
                                                    {itemTC?.HoldReason}
                                                  </strong>
                                                </Tooltip>
                                              }
                                            >
                                              <span>
                                                <i
                                                  className="fa fa-info-circle ms-2"
                                                  style={{
                                                    cursor: "pointer",
                                                    // color: "#9698ab",
                                                  }}
                                                ></i>
                                              </span>
                                            </OverlayTrigger>
                                          </>
                                        )}
                                      </Link>
                                    </React.Fragment>
                                  ))}
                                </td>
                                {/* </tr>
                                    </table>
                                  </div>
                                </td> */}
                              </tr>
                            ) : (
                              ""
                            )}
                          </React.Fragment>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={7} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {/* <div className="d-sm-flex text-center justify-content-between  mt-1">
                    <div>
                      <label style={{ color: "#ed7c79" }}>
                        <i className="fa fa-circle"></i>
                        &nbsp; Pending
                      </label>
                    </div>
                    <div>
                      <label style={{ color: "#80c9ff" }}>
                        <i className="fa fa-circle"></i>
                        &nbsp; Done
                      </label>
                    </div>
                    <div>
                      <label style={{ color: "#4aa493" }}>
                        <i className="fa fa-circle"></i>
                        &nbsp; Partial Done
                      </label>
                    </div>
                  </div> */}
                  <hr className="mt-0 mb-1"></hr>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div>
      <Modal
        className="fade"
        show={showMachiningOutwardModal}
        onHide={setShowMachiningOutwardModal}
        size={"xl"}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Machining Outward</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowMachiningOutwardModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <FormikProvider value={formikMachiningOutward}>
              <Form onSubmit={formikMachiningOutward.handleSubmit}>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Vendor"
                      name="VendorName"
                      placeholder={"Vendor Name"}
                      component={CustomInput}
                      disabled={true}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Outward No"
                      name="MachiningOutwardNo"
                      placeholder={"Outward No"}
                      component={CustomInput}
                      disabled={true}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Outward Date"
                      name="OutwardDate"
                      placeholder={"Outward Date"}
                      component={CustomInput}
                      disabled={true}
                    />
                  </Col>

                  <Col lg={3}>
                    <Field
                      label="Expected Date of Return"
                      name="ExpectedDate"
                      placeholder={"Expected Date of Return"}
                      component={CustomInput}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={InwardRemarks ? 6 : 12}>
                    <Field
                      label="Remarks"
                      name="Remarks"
                      rows={InwardRemarks ? 3 : 2}
                      placeholder={"Enter Remarks"}
                      component={CustomTextArea}
                      disabled={true}
                    />
                  </Col>
                  {InwardRemarks ? (
                    <Col lg={6}>
                      <Field
                        label="Inward Remarks"
                        name="InwardRemarks"
                        rows={3}
                        placeholder={"Enter Inward Remarks"}
                        component={CustomTextArea}
                        disabled={true}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
                <hr className="mt-1 mb-1"></hr>

                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="VendorProcessDetail-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="VendorProcessDetail-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="25%">Process</th>
                              <th width="15%">TC No</th>
                              <th width="15%">Note</th>
                              <th width="10%">Qty</th>
                              <th width="10%">Length</th>
                              <th width="10%">Thickness</th>
                              <th width="5%">Invoicing</th>
                              <th width="10%" style={{ textAlign: "left" }}>
                                Status
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ListOfVendorProcessDetail?.length > 0 ? (
                              ListOfVendorProcessDetail?.map((item, indx) => (
                                <tr key={indx}>
                                  <td
                                    style={{
                                      minWidth: "150px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.ProcessName}
                                  </td>
                                  <td style={{ minWidth: "100px" }}>
                                    {item.TCNo}{" "}
                                    {item?.IsHold == true && (
                                      <>
                                        <b>[Hold]</b>
                                        <OverlayTrigger
                                          trigger={["hover", "focus"]}
                                          key={indx}
                                          responsive={true}
                                          overlay={
                                            <Tooltip className="toltip-popover">
                                              <strong className="p-1">
                                                {item?.HoldReason}
                                              </strong>
                                            </Tooltip>
                                          }
                                        >
                                          <span>
                                            <i
                                              className="fa fa-info-circle ms-2"
                                              style={{
                                                cursor: "pointer",
                                                color: "#9698ab",
                                              }}
                                            ></i>
                                          </span>
                                        </OverlayTrigger>
                                      </>
                                    )}
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "200px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.Note}
                                  </td>
                                  <td style={{ minWidth: "100px" }}>
                                    {item.Qty}
                                  </td>
                                  <td style={{ minWidth: "100px" }}>
                                    {item.Length}
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "100px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.Thickness}
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "100px",
                                      whiteSpace: "normal",
                                      textAlign: "center",
                                    }}
                                  >
                                    {item.IsSelectedInvoicing ? "Yes" : "No"}
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "80px",
                                      whiteSpace: "normal",
                                      textAlign: "left",
                                    }}
                                  >
                                    {item.OutwardStatusName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={7}
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  <div>{"No options"}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>

                {/* {showMachiningOutwardModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )} */}
              </Form>
            </FormikProvider>
          </Modal.Body>
          {/* <Modal.Footer>
            <Button
              variant="secondary light"
              onClick={() => setShowMachiningOutwardModal(false)}
            >
              Close
            </Button>
          </Modal.Footer> */}
        </Spin>
      </Modal>
    </>
  );
};

export default MachineOutward;
